export default {
  cognito: {
    USER_POOL_ID: 'eu-west-2_thNk1OalQ',
    REGION: 'eu-west-2',
    APP_CLIENT_ID: '5bajq7erbrm8qg8ptqabqrngsu'
  }
}
